import { forwardRef } from "react";
import {
  HEADED_SECTION_DEFAULTS,
  THeadedSectionProps,
} from "@/ui/components/data-display/HeadedSection/HeadedSection.config";
import {
  HeadedSectionContent,
} from "@/ui/components/data-display/HeadedSection/HeadedSectionContent";
import {
  HeadedSectionHeader,
} from "@/ui/components/data-display/HeadedSection/HeadedSectionHeader";
import { Section } from "@/ui/components/layout/Section";

export const HeadedSection = forwardRef<HTMLElement, THeadedSectionProps>(
  (
    {
      title,
      theme = HEADED_SECTION_DEFAULTS.theme,
      "data-component": component = HEADED_SECTION_DEFAULTS["data-component"],
      icon,
      children,
    },
    ref,
  ) => (
    <Section ref={ref} data-component={component}>
      <HeadedSectionHeader title={title} theme={theme} icon={icon} />
      <HeadedSectionContent theme={theme}>
        { children }
      </HeadedSectionContent>
    </Section>
  ),
);

HeadedSection.displayName = "HeadedSection";
